import { atom, createStore } from 'jotai';

export const currentModalAtom = atom<string | null>(null);

export const openedInfoModalsAtom = atom(new Map<string, number>());

export const openedInfoModalsStore = createStore();

export const addOpenedInfoModal = (modalId: string) => openedInfoModalsStore.set(openedInfoModalsAtom, (prev) => {
  const next = new Map(prev);
  next.set(modalId, next.get(modalId) ? (next.get(modalId) ?? 0) + 1 : 1);
  return next;
});

export const setCurrentModalId = (modalId: string) => openedInfoModalsStore.set(currentModalAtom, modalId);

export const isOpenedInfoModal = (modalId: string) => (openedInfoModalsStore.get(openedInfoModalsAtom).get(modalId) ?? 0) > 1;

export const getOpenedInfoModalCounter = (modalId: string) => openedInfoModalsStore.get(openedInfoModalsAtom).get(modalId) ?? 0;

export const getCurrentInfoModalCounter = () => openedInfoModalsStore.get(openedInfoModalsAtom).get(openedInfoModalsStore.get(currentModalAtom) ?? '') ?? 0;
